import { Box, SxProps, Theme, Typography } from '@mui/material'
import { memo } from 'react'

export const BarLabelView = memo(({ 
    label, 
    color, 
    type = 'solid',
    stripeRotation = 45,
    onClick,
    disabled = false,
    dimmed = false,
    textVariant = 'body2',
    textColor = 'text.primary',
    labelSx,
}: { 
    label: string, 
    color: string,
    type?: 'solid' | 'striped' | 'hollow',
    stripeRotation?: number,
    onClick?: () => void,
    disabled?: boolean,
    dimmed?: boolean,
    textVariant?: 'caption' | 'body2',
    textColor?: string,
    labelSx?: SxProps<Theme>,
}) => {
    const renderIcon = () => {
        if (type === 'striped') {
            const patternId = `pattern-${label.replace(/\s+/g, '-')}-${color.replace('#', '')}-${stripeRotation}`
            return (
                <svg width="10" height="10" style={{ borderRadius: '2px' }}>
                    <defs>
                        <pattern
                            id={patternId}
                            patternUnits="userSpaceOnUse"
                            width="8"
                            height="8"
                            patternTransform={`rotate(${stripeRotation})`}
                        >
                            <rect width="4" height="8" fill={color} opacity="0.3" />
                            <rect x="4" width="4" height="8" fill={color} opacity="0.6" />
                        </pattern>
                    </defs>
                    <rect width="10" height="10" fill={`url(#${patternId})`} rx="2" />
                </svg>
            )
        } else if (type === 'hollow') {
            return (
                <Box sx={{ 
                    width: 10, 
                    height: 10, 
                    bgcolor: 'transparent',
                    border: `1.5px solid ${color}`,
                    borderRadius: '2px'
                }} />
            )
        } else {
            return <div style={{ width: 10, height: 10, backgroundColor: color, borderRadius: '2px' }} />
        }
    }

    return (
        <Box
            component={onClick ? 'button' : 'div'}
            type={onClick ? 'button' : undefined}
            onClick={disabled ? undefined : onClick}
            sx={{
                display: 'flex',
                gap: 0.5,
                alignItems: 'center',
                border: 'none',
                bgcolor: 'transparent',
                p: 0,
                m: 0,
                cursor: onClick && !disabled ? 'pointer' : 'default',
                opacity: disabled || dimmed ? 0.45 : 1,
                '&:hover': onClick && !disabled
                    ? { opacity: dimmed ? 0.65 : 0.85 }
                    : undefined,
            }}
        >
            {renderIcon()}
            <Typography variant={textVariant} color={textColor} sx={labelSx}>
                {label}
            </Typography>
        </Box>
    )
})